module.exports = __webpack_public_path__ + "img/ghaflankooh.52104b27.png";